export default {
    header: 'My Account',
    subHeader: 'Change your plan, update your billing info, and download your invoices.',

    noPlans: 'No plans yet.',
    subscribeToPlan: 'Subscribe to a plan',

    tabs: {
        settings: 'Settings',
        subscriptions: 'Subscriptions',
        purchases: 'Purchases',
        invoices: 'Invoices',
        payment: 'Payment',
    },

    settings: {
        details: {
            editProfile: 'View / Edit Profile',
            yourProfileScore: 'Your profile is <strong>{score}% complete</strong>',
        },

        deleteAccount: {
            header: 'Delete Account',
            description:
                "This action is irreversible and will result in the permanent removal of all your personal data from our system including your profile, CV's, and uploaded documents. Please note that once your account is deleted, you will lose access to your account and all associated services. The process can take up to 72 hours, a confirmation email will be sent upon completion.",
            buttonRequestDeletion: 'Request account deletion',
            buttonRequestedDeletion: 'Account deletion requested',

            deleteDialog: {
                title: 'Delete account',
                content: 'Are you sure you want to delete your account?',
                label: 'Type in {0} to confirm',
                buttonDeleteAccount: 'Delete account',
            },
            confirmDialog: {
                title: 'Account deletion requested',
                content:
                    'Your account deletion request has been submitted. The process can take up to 72 hours.',
            },
        },
    },

    planDetails: {
        monthsAccess: '{n} month access | {n} months access',
        coursesAndProjects: '{courses} courses and {projects} Guided Projects',
        daysLeft: '{n} day left | {n} days left',
        renewsOn: 'renews on {date}',
        willNotRenew: 'will not renew',
        expired: 'Expired',

        renew: {
            renewSubscription: 'Renew subscription',
            error: 'Could not renew subscription',
        },

        cancel: {
            cancelSubscription: 'Cancel subscription',
            prompt: 'Are you sure you want to cancel this subscription? You will still be able to use the service until the end of the current subscription period.',
            completed: 'Subscription canceled',
            error: 'Could not cancel subscription. Please try again, or contact us in the bottom right corner of the page.',
        },
    },

    nonSubscriptionAccess: {
        headerPurchase: '6 month access',
        headerInvite: 'Access by invite',
        headerAccessCode: 'Access by access code',

        expiredText:
            'Your access to Coursera has expired. You can click the button below to get access again.',
        getAccess: 'Get access',

        purchaseText:
            'If you wish, you can set up a subscription now, that will take effect when the access code period expires. You will not be billed until then, and can cancel the pending subscription at any time.',
        setupSubscription: 'Setup subscription',
    },
    billingDetails: {
        header: 'Billing details',
        edit: 'Edit billing details',
        yourNextInvoice: 'Your next invoice',
        name: 'Name',
        streetAddress: 'Street address',
        postalCodeCityCountry: 'Postal code, city, country',

        modal: {
            country: 'Country',
            state: 'State',
            city: 'City',
            postalCode: 'Postal code',
            line1: 'Address line 1',
            line2: 'Address line 2',

            shipping: 'Shipping',
            sameAsAddress: 'Same as billing address',
            name: 'Name',
            phone: 'Phone number',
        },

        errors: {
            loadNextInvoice: 'Could not load next invoice',
            loadBillingAccount: 'Could not load billing account',
            updateBillingAccount: 'Could not update billing account',
        },
    },
    paymentMethod: {
        header: 'Payment method',
        subHeader: 'This is the payment method for this particular subscription.',
        edit: 'Edit payment method',
        cardInformationLabel: 'Card information',
        cardInformationText: '{cardType} ending in <strong>{lastDigits}</strong>',
        cardNameLabel: 'Name on card',
        cardExpirationLabel: 'Expiration',

        description:
            'Here you manage the payment methods connected to your account. The payment method set as default will be used for all subscriptions, unless a subscription has specifically set a different payment method.',
        addPaymentMethod: 'Add payment method',
        setDefault: 'Set default',
        selected: 'Selected',

        removeDefaultDisclaimer: 'You cannot remove your default payment method',
        promptRemove:
            'Are you sure you want to remove the payment method "{cardType} ending in {lastDigits}"?',
    },
    invoices: {
        header: 'Invoices',
        date: 'Date',
        items: 'Items (hover for info)',
        status: 'Status',
        amount: 'Amount',
        download: 'Download',

        nItems: '{n} item(s)',
        noInvoices: 'No invoices',
    },
    purchases: {
        headers: {
            product: 'Product',
            date: 'Date',
            price: 'Price',
        },

        noPurchases: 'No purchases',
    },
};
